import React from "react";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ClientFlow] React crash:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-muted/40 p-4">
          <div className="max-w-md w-full bg-card border border-border rounded-2xl p-8 text-center" data-testid="error-boundary">
            <h1 className="font-heading text-2xl font-bold">Noe gikk galt</h1>
            <p className="text-muted-foreground mt-2 text-sm">
              Vi beklager — siden krasjet uventet. Prøv å laste på nytt.
            </p>
            <Button
              className="mt-6 rounded-xl bg-primary hover:bg-primary/90"
              onClick={() => window.location.reload()}
              data-testid="error-reload-btn"
            >
              Last siden på nytt
            </Button>
            {process.env.NODE_ENV === "development" && this.state.error && (
              <pre className="mt-4 p-3 rounded-xl bg-muted text-left text-xs overflow-auto max-h-40">
                {String(this.state.error?.message || this.state.error)}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
